<div class="project-component" style="margin-top: 20px;">

  <div style="width: 190px;margin: 0 0 0 40px; display: flex; flex-direction: row; align-self: center">
    <div class="filterItem" style="flex:1 0 200px">
      <mat-select [(value)]="from">
        <mat-option [value]="lastLogin">Since last login</mat-option>
        <mat-option [value]="lastMonth">Last month</mat-option>
        <mat-option [value]="lastYear">Last year</mat-option>
        <mat-option [value]="'specify'">Specify</mat-option>
      </mat-select>
    </div>
    <div class="filterItem" style="flex:1 0 200px" *ngIf="from == 'specify'">
      <mat-form-field class="example-full-width">
        <mat-label>From</mat-label>
        <input matInput placeholder="From" [(ngModel)]="from" [matDatepicker]="fromPicker">
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="filterItem" style="flex:1 0 200px" *ngIf="from == 'specify'">
      <mat-form-field class="example-full-width">
        <mat-label>To</mat-label>
        <input matInput placeholder="To" [(ngModel)]="to" [matDatepicker]="toPicker">
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="filterItem" style="flex:1 0 200px">
      <mat-form-field>
        <mat-label>User</mat-label>
        <mat-select placeholder="User" [(value)]="userIds" multiple>
          <mat-option *ngFor="let user of users" [value]="user.userId">{{ getFullName(user) }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="filterItem" style="flex:1 0 200px">
      <mat-form-field>
        <mat-label>Module</mat-label>
        <mat-select placeholder="Area" [(value)]="area">
          <mat-option [value]="0">Project</mat-option>
          <mat-option [value]="1">Control Items</mat-option>
          <mat-option [value]="2">Action Plans</mat-option>
          <mat-option [value]="3">IT Profile</mat-option>
          <mat-option [value]="4">Other</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="filterItem" style="flex:1 0 200px" *ngIf="area == 0">
      <mat-form-field>
        <mat-label>Project</mat-label>
        <mat-select placeholder="Project" [(value)]="projectId">
          <mat-option *ngFor="let project of projects" [value]="project.projectId">{{ project.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="filterItem" style="flex:1 0 200px" *ngIf="area == 0">
      <mat-select placeholder="Changed" [(value)]="changes" multiple>
        <mat-option [value]="0">All</mat-option>
        <mat-option [value]="1">Control Status</mat-option>
        <mat-option [value]="2">Evidence</mat-option>
        <mat-option [value]="3">ICS</mat-option>
        <mat-option [value]="4">POAM</mat-option>
      </mat-select>
    </div>
    <div class="filterItem" style="flex:0 0 auto">
      <button mat-raised-button (click)="updateLogs()">Load</button>
    </div>
  </div>
  <h3 style="margin: 20pt 0 0 40px;" *ngIf="!data || !data.length">
    No Activity
  </h3>
  <p-table
    [value]="data"
    #table
    [rows]="100"
    [paginator]="false"
    [pageLinks]="3"
    [rowsPerPageOptions]="[10, 20, 50, 100]"
    [style]="{'margin-top':'10px'}"
    selectionMode="single"
    [resizableColumns]="true"
    [reorderableColumns]="true">

    <ng-template pTemplate="header">
      <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
        <th *ngFor="let col of cols" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width || 'auto'}">
          {{ col.header }}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                      ariaLabelDesc="Activate to sort in descending order"
                      ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
      </tr>
      <tr>
        <th *ngFor="let col of cols" [ngSwitch]="col.field">
          <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                 (input)="table.filter($event.target['value'], col.field, 'contains')">
          <span *ngSwitchCase="'date'"></span>
          <p-multiSelect *ngSwitchCase="'state'" multiple
                         [options]="[{label: 'Updated', value: 16}, {label: 'Deleted', value: 8}, {label: 'Added', value: 4}]"
                         [style]="{'width':'100%'}"
                         (onChange)="table.filter($event.value, 'state', 'in')"></p-multiSelect>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
      <tr>
        <td *ngFor="let col of cols">
          <div *ngIf="col.field != 'date'">{{ item[col.field] }}</div>
          <div *ngIf="col.field == 'date'">
            {{ item[col.field] | date:'shortDate' }}
            {{ item[col.field] | date:'shortTime' }}
          </div>
        </td>

      </tr>
    </ng-template>
  </p-table>
</div>
